/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Text from '../text/Text';
import Note, { NoteProps } from '../../molecules/note/Note';

interface ProgressItemProps {
  title?: string;
  subtitle?: string;
  time?: string;
}
interface LabelProps {
  index: number;
  item: ProgressItemProps;
}
export interface ProgressStepsProps {
  size?: 'sm' | 'md' | 'lg';
  color?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | 'dark'
    | 'light';
  className?: string;
  current?: number;
  items: ProgressItemProps[];
  mode?: 'hr' | 'vr';
  timeline?: boolean;
  showNote?: boolean;
  note?: NoteProps;
  onClick?: (id: number) => void;
}

const ProgressSteps = ({
  size = 'md',
  color = 'primary',
  className,
  current = 0,
  items,
  mode,
  timeline = false,
  showNote = false,
  note,
  onClick,
}: ProgressStepsProps) => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    setActive(current);
  }, [current]);

  const Labels = ({ item, index }: LabelProps) => {
    return (
      <>
        <Text
          className="flex-wrap"
          size={size == 'lg' ? 'md' : size}
          weight="semibold"
          color={index != active ? 'title' : color}
        >
          {item.title}
        </Text>
        <Text
          className="flex-wrap"
          size={size == 'lg' ? 'md' : size}
          weight="normal"
          color={index != active ? 'subtitle1' : color}
        >
          {item.subtitle}
        </Text>
      </>
    );
  };

  return (
    <div
      className={classNames('position-relative z-1', {
        'd-flex justify-content-between': mode == 'hr',
      })}
    >
      {items?.map((item, index) => (
        <div
          key={index}
          className={classNames(
            `progress-steps-${color} progress-steps-size-${size} progress-steps-top-${size} position-relative d-flex align-items-center`,
            {
              'progress-steps-hr flex-column': mode == 'hr',
              'progress-steps-timeline gap-10': mode == 'vr' && timeline,
              'progress-steps-vr gap-6': mode == 'vr',
            },
            {
              'progress-steps-active': index + 1 == active,
              'progress-steps-completed': index + 1 < active,
            },
            className,
          )}
        >
          <div
            className={classNames('progress-steps-icon pointer', {
              'progress-steps-tick': index + 1 < active && !timeline,
              'progress-steps-circle': index + 1 >= active && !timeline,
            })}
            onClick={() => onClick(index)}
          >
            {timeline && (
              <div>
                <Text size={size == 'lg' ? 'md' : size} weight="semibold">
                  {item.time}
                </Text>
              </div>
            )}
          </div>
          {mode == 'hr' ? (
            <div className="d-flex flex-column align-items-center px-6 pt-6">
              <Labels item={item} index={index + 1} />
            </div>
          ) : (
            <div
              className={classNames('d-flex flex-column py-5', {
                'flex-fill gap-6': showNote,
              })}
            >
              <div className="d-flex flex-column">
                <Labels item={item} index={index + 1} />
              </div>
              {showNote && <Note body={note.body} classes={note.classes} />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default ProgressSteps;
